export function dateUpdate(stringDate: string) {
  const dateSplit = stringDate.split('/');
  dateSplit.forEach((e, i) => {
    if (e.length < 2) {
      dateSplit[i] = '0' + e;
    }
  });
  const updatedDate = dateSplit.join('/');
  return updatedDate;
}
